import { render, staticRenderFns } from "./CommunicationBooksIndex.vue?vue&type=template&id=5bbe4b46&scoped=true"
import script from "./CommunicationBooksIndex.vue?vue&type=script&lang=js"
export * from "./CommunicationBooksIndex.vue?vue&type=script&lang=js"
import style0 from "./CommunicationBooksIndex.vue?vue&type=style&index=0&id=5bbe4b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbe4b46",
  null
  
)

export default component.exports